import { api } from './api'

export interface WaitingListEntry {
  key?: number
  userId: number
  sessionId: number
  regcode: number
  deleted: boolean
  notified: boolean
  notifiedTimestamp: string
  timeStamp: string
  expDate: string
  sort: number
  // 'add' = pending, 'register' = got a spot, 'reject' = denied, 'remove' = removed
  action: string
  actionTimestamp: string
}

// Must match EventSessionWaitinglistController.NoWaitingListMessage in escworks-rest-api
export const WAITING_LIST_DISABLED_ERROR = 'This session does not have a waiting list.'

export function isWaitingListDisabledError(error: any): boolean {
  return error?.response?.status === 400 && error.response.data?.error === WAITING_LIST_DISABLED_ERROR
}

// Normalises any API response shape into a flat array of entries + a total count
export function parseWaitingListResponse(raw: any): { entries: WaitingListEntry[]; total: number } {
  if (Array.isArray(raw)) {
    return { entries: raw as WaitingListEntry[], total: raw.length }
  }
  if (raw && typeof raw === 'object') {
    const list: WaitingListEntry[] =
      raw.eventSessionWaitinglistDtos ??
      raw.eventSessionWaitingListDtos ??
      raw.data ?? raw.results ?? raw.items ?? raw.records ?? []
    const total: number =
      raw.totalCount ?? raw.total ?? raw.count ?? raw.totalRecords ?? list.length
    return { entries: list, total }
  }
  return { entries: [], total: 0 }
}

export const waitingListService = {
  addToWaitingList: (sessionId: number, userId: number): Promise<any> => {
    const now = new Date().toISOString()
    return api.post('/legacydb/eventsessionwaitinglist', {
      userId,
      objId: sessionId,
      regcode: 0,
      deleted: false,
      notified: false,
      notifiedTimestamp: now,
      timeStamp: now,
      expDate: now,
      sort: 0,
      action: 'add',
      actionTimestamp: now,
    })
  },

  // All active (non-deleted) entries for a session
  getWaitingListForSession: (sessionId: number): Promise<any> => {
    const filter = encodeURIComponent(`sessionid:eq:${sessionId}`)
    return api.get(
      `/legacydb/eventsessionwaitinglist?filter=${filter}&descending=false&page=1&pageSize=1000`
    )
  },

  // All active/inactive entries for a user, newest first
  getWaitingListForUser: (userId: number): Promise<any> => {
    const filter = encodeURIComponent(`userid:eq:${userId}`)
    return api.get(
      `/legacydb/eventsessionwaitinglist?filter=${filter}&descending=true&page=1&pageSize=1000`
    )
  },

  removeFromWaitingList: (key: number): Promise<any> => {
    return api.put(`/legacydb/eventsessionwaitinglist/${key}`, {
      deleted: true,
      action: 'remove',
      actionTimestamp: new Date().toISOString(),
    })
  },
}
